import styled from "styled-components";
import { ScreenSizes, Sizes } from "../styles/Themes";
import ConnectWalletButton from "../components/buttons/ConnectWalletButton";
import LoginVideo from "../components/loginPage/LoginVideo";
import LoginExplain from '../components/loginPage/LoginExplain';
import {MainLogo} from "../styles/Icons";
import ConnectWalletButtonEmergency from '../components/buttons/ConnectWalletButton_emergency';

const MainContentsEl = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: auto;
  min-height: calc(100vh - ${Sizes.HeaderHeight} - ${Sizes.FooterHeight});
  padding-top: calc(${Sizes.HeaderHeight} + 16px);
  gap: 24px;
  padding-bottom: 120px;
  filter: ${(props) => (props.blur ? "blur(2px);" : "none;")};
  @media (max-width: ${ScreenSizes.mobile}) {
    padding-top: calc(${Sizes.MobileHeaderHeight} + 16px);
    gap: 10px;
    padding-left: 8px;
    padding-right: 8px;
    box-sizing: border-box;
  }
`;

const MainLogoEl = styled.div`
  margin-top: 42px;
  width:601px;
  height:auto;
  @media (max-width: ${ScreenSizes.mobile}) {
     margin-top: 47px;
     width:100%;
   }
`;

function LoginPage() {
  return (
    <>
      <MainContentsEl>
        <MainLogoEl>
        <MainLogo />
        </MainLogoEl>
        <LoginVideo />
        <LoginExplain/>
        <ConnectWalletButton type={"main"}/>
        {/* <ConnectWalletButtonEmergency type={"main"}/> */}
      </MainContentsEl>
    </>
  );
}
export default LoginPage;
